import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import isExternalHref from "@casino/legacy/shared/utils/router/isExternalHref";
import type { LinkProps } from "..";
import useParseExternalHref from "./useParseExternalHref";
import usePatchHrefLocale from "./usePatchHrefLocale";

const useNextLink = (props: LinkProps) => {
  const { pathPrefix } = useAppContext();
  const { patchHrefLocale } = usePatchHrefLocale();
  const href = props.href;
  const { parseExternalHref } = useParseExternalHref();
  const parsedHref = parseExternalHref(href);
  const isExternal = isExternalHref(parsedHref);
  if (!pathPrefix) {
    return { href: patchHrefLocale(href), isExternal };
  }
  const newHref =
    isExternal || parsedHref.includes(pathPrefix)
      ? parsedHref
      : `${pathPrefix}${parsedHref}`;

  return { href: patchHrefLocale(newHref), isExternal };
};

export default useNextLink;
